module.exports = __webpack_public_path__ + "img/rome.4d8e06be.png";